export const i18nHomePage = {
  summary: {
    production: 'Producción',
    uptime: 'Tiempo de actividad',
    savings: 'Ahorros',
    co: 'CO²e',
    so: 'SO²',
    health: 'Salud',
  },
  card: {
    labels: {
      empty: 'Sin alarmas',
      closed: 'Sin alarmas',
      open: 'Alarmas',
      investigating: 'Investigando',
      no_data: 'Sin datos',
      delay: 'Retraso de sensores',
      active: 'Sensores OK',
    },
  },
};
